var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 22",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 10H10.86a4 4 0 0 0-7.72 0H0v2h3.14a4 4 0 0 0 7.72 0H22ZM7 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 3h-1.14a4 4 0 0 0-7.72 0H0v2h13.14a4 4 0 0 0 7.72 0H22Zm-5 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2M17 14a4 4 0 0 0-3.86 3H0v2h13.14a4 4 0 0 0 7.72 0H22v-2h-1.14A4 4 0 0 0 17 14m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.1be13295b26f475c88c31f0fbca92a94.svg";